import React, {useEffect, useState} from 'react';
import {Button, DatePicker, Descriptions, Modal, notification, Popconfirm, Select, Space} from "antd";
import {formatCurrency} from "../../utils/monetary";
import {useDispatch, useSelector} from "react-redux";
import {arrhesBooking, productBooking, updateBooking} from "../../store/actions/BookingAction";
import useProducts from "../../hooks/useProducts";
import InputNumberFormated from "./InputNumberFormated";
import {SaveOutlined} from "@ant-design/icons";

import locale from 'antd/es/date-picker/locale/fr_FR';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import BookingForm from "./BookingForm";

const arrhesInitial = {
	deposit_tenant: null,
	deposit_at: dayjs(),
}
const initialProduct = {building:null, apartment:null};
function BookingModal({ open, onClose, booking: initialBooking }) {

	const [product, setProduct] = useState(initialProduct);
	const [error, setError] = useState(false);
	const [editing, setEditing] = useState({period:false,deposit:false});
	const [arrhes, setArrhes] = useState(arrhesInitial);

	const {fromBuilding, loading, data, error: productsError} = useProducts();
	const dispatch = useDispatch();

	const [api, contextHolder] = notification.useNotification();

	// Récupérez la version à jour de la réservation depuis le store
	const booking = useSelector(state =>
		state.bookings.data.find(b => b.id === initialBooking?.id) || initialBooking
	);

	useEffect(() =>  {
		if (initialBooking) {
			fromBuilding(initialBooking.building_id).then();
		}
	},[initialBooking, fromBuilding])

	useEffect(() => {
		if (open) {
			setEditing(false);
			setProduct({...initialProduct, building: booking?.building_id});
			setError(false);
			setArrhes(arrhesInitial);
		}
	}, [open, booking]);


	// Gérer l'affichage de l'erreur dans un useEffect
	useEffect(() => {
		if (productsError) {
			api.error({
				message: 'Réservations',
				description: productsError,
				placement: 'topRight',
			});
		}
	}, [productsError, api]);

	const handleChangeLot = (value) => {
		setProduct({...product, apartment: value});
		setError(false);
	}

	// Update la liste des lots dans BookingForm au changement d'immeuble
	const handleChangeBuilding = async (value) => {
		setProduct({building: value, apartment: null});
		await fromBuilding(value);
		setError(false);
	}

	// assigne product
	const handleClick = async () => {
		if (!product.apartment) {
			setError(true);
			return;
		}
		const {requete} = await dispatch(
			productBooking(booking.id, {
				building_id: product.building,
				product_id: product.apartment
			})
		);
				if (onClose) onClose(requete);
	}


	// Ajout acompte
	const handleDeposit = async (id) => {
		if (arrhes) {
			await dispatch(arrhesBooking(id, arrhes));
			setArrhes(arrhesInitial);
			//onClose(null);
		}
		setEditing(false);
	}

	// maj reservation
	const handleSubmit = async (values) => {
		await dispatch(updateBooking(booking.id, values));
	}

	// Si aucune réservation n'est sélectionnée, on n'affiche rien.
	if (!booking) {
		return null;
	}

	return (
		<>
		{contextHolder}
		<Modal
			title={`Détails de la réservation`}
			open={open}
			onOk={handleClick}
			onCancel={() => onClose(null)}
			okText="Valider la selection du lot"
			//maskClosable={false}
			//keyboard={false}
			//footer={null} // On utilise un bouton personnalisé ou aucun bouton
			width={800}
			className={"booking-modal"}
		>
			<Space direction="vertical" size="middle" style={{width: '100%'}}>

				<BookingForm
					booking={booking}
					handleSubmit={handleSubmit}
					handleChangeBuilding={handleChangeBuilding}
					buildings={data?.buildings}
				/>

				<Descriptions
					bordered
					column={1}
					size="middle"
					styles={{label:{ width: '200px' }}}
				>
					<Descriptions.Item label="Acompte locataire" span={1}>
						<div
							style={{display: 'flex', gap: '5px', alignItems: 'center'}}
							onBlur={(e) => {
								// e.relatedTarget est l'élément qui reçoit le focus.
								// Si cet élément n'est pas à l'intérieur de la div (currentTarget), on ferme.
								if (!e.currentTarget.contains(e.relatedTarget)) {
									// Un léger délai permet aux actions (comme le clic sur Valider) de s'exécuter
									!arrhes?.deposit_tenant && setTimeout(() => setEditing({...editing, deposit: false}), 200);
								}
							}}
						>
							{ editing.deposit ? (
								<>
									<InputNumberFormated
										style={{flex: '1', maxWidth: 150}}
										asNegative={true}
										autoFocus={true}
										//onBlur={() => !arrhes && setTimeout(() => setEditing(false), 100)}
										onChange={(value) => setArrhes(prev => ({...prev, deposit_tenant: value}))}
									/>
									<DatePicker
										disabled={!arrhes?.deposit_tenant}
										style={{flex: '1', maxWidth: 150}}
										allowClear={false}
										locale={locale}
										value={arrhes?.deposit_at || dayjs()}
										format="DD/MM/YYYY"
										onChange={(date) => setArrhes(prev => ({
											...prev,
											deposit_at: date
										}))}
									/>
									<Popconfirm
										title="Réservation en attente"
										description="Êtes-vous sûr de vouloir ajouter cet acompte ?"
										onConfirm={() => handleDeposit(booking.id).then()}
										onCancel={() => {
											setArrhes(null);
											setEditing({...editing, deposit: false});
										}}
										okText="Oui"
										cancelText="Non"
										//okButtonProps={{ danger: true }}
									>
										<Button
											disabled={!arrhes?.deposit_tenant}
											type="primary"
											icon={<SaveOutlined />}
											size="middle"
											//onClick={() => handleSubmit(booking.id).then()}
										/>
									</Popconfirm>
								</>
							) : (
								<span
									onClick={() => setEditing({...editing, deposit: true})}
									style={{
										cursor: 'pointer',
										width: 130,
										border: '1px solid #d9d9d9',
										padding: '4px 10px',
										borderRadius: '5px',
										transition: 'all 0.3s'
									}}
								>
									{formatCurrency(booking.deposit_tenant)}
								</span>
							)}
						</div>

					</Descriptions.Item>
					<Descriptions.Item label="Lot" span={1}>
						<div style={{ width: '100%', display: 'flex', gap: '10px' }}>
						<Select
							status={error ? 'error' : undefined}
							// allowClear
							showSearch
							style={{ flex: 1, minWidth: 0 }}
							value={product.apartment}
							loading={loading}
							onChange={handleChangeLot}
							onClear={() => setError(false)}
							options={data?.products?.map((lot) => ({ label: `${lot.reference} - ${lot?.type_lot?.libelle}`, value: lot.id }))}
						/>
						</div>
						{error && (
							<div style={{ color: '#ff4d4f', fontSize: '14px', marginTop: '4px' }}>
								Veuillez sélectionner un lot
							</div>
						)}
					</Descriptions.Item >
					{/* Ajoutez ici d'autres détails que vous souhaitez afficher */}
				</Descriptions>
			</Space>
		</Modal>
			</>
	)
}

export default BookingModal;